export default __webpack_public_path__ + "static/media/Grupo6133.47fd22b4.svg";